<template>
  <div class="add-motivo-rechazo">
    <h1>Nuevo Motivo de Rechazo</h1>
    
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <div class="card p-4 bg-light">
      <MotivoRechazoForm
        :motivoRechazo="motivoRechazo"
        :loading="saving"
        :isEditing="false"
        @submit="saveMotivoRechazo"
        @cancel="goBack"
      />
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import AddMotivoRechazoViewController from '../controllers/AddMotivoRechazoViewController';
import MotivoRechazoForm from '../components/MotivoRechazoForm.vue';

export default {
  name: 'AddMotivoRechazoView',
  components: {
    MotivoRechazoForm
  },
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new AddMotivoRechazoViewController()
    };
  },
  computed: {
    motivoRechazo() {
      return this.controller.motivoRechazo;
    },
    saving() {
      return this.controller.saving;
    },
    error() {
      return this.controller.error;
    }
  },
  created() {
    this.controller.initialize();
  },
  methods: {
    async submitForm() {
       const result = await this.controller.saveMotivoRechazo();
       
       if (result.success) {
         this.$mgkResponse.handleResponse(result.response).then(() => {
           this.$router.push('/motivos-rechazo');
         });
       } else {
         this.error = result.message;
       }
     },
    
    updateField(field, value) {
      this.controller.updateField(field, value);
    },
    
    goBack() {
      this.$router.push('/motivos-rechazo');
    }
  }
}
</script>

<style scoped>
.add-motivo-rechazo {
  padding: 20px;
}
</style>
